/** Faits recopiés du PDF Sépaq por_fiche_technique_or_2026 (hash 2b8330d2…). */

export const SEPAQ_PDF = "/docs/por_fiche_technique_or_2026.pdf";
export const SEPAQ_PDF_SHA256 = "2b8330d2a671577ab7717ef2f4fceefd0ad5f44dacdcfd15d5c4538dc51e7387";

export const SEPAQ_OFFICIAL = {
  place: "Accueil de la Réserve faunique de Portneuf",
  street: "229, rue du Lac-Vert",
  city: "Rivière-à-Pierre, QC",
  postal: "G0A 3A0",
  hours: "Ouvert de 8 h à 18 h",
  sector: "Secteur 4 — Desrochers",
  meeting: "Rendez-vous d’enregistrement : 13 h 45",
  cabin: "Accès au chalet après l’enregistrement",
  huntStart: "Début de la chasse : 16 h 30 le jour d’arrivée",
  huntEnd: "Fin de la chasse : 16 h la dernière journée",
  checkout: "Sortie de l’hébergement : 12 h (midi) la dernière journée",
  phone: "Réserve faunique de Portneuf : 418 323-2021",
  game: "Station d’enregistrement du gibier : Accueil de la Réserve faunique de Portneuf, Rivière-à-Pierre",
  onSite: [
    "Chambre froide : à l’accueil de la réserve",
    "Traîneaux et treuils : quantité limitée à l’accueil",
    "Potence, palan et jambier : près de l’hébergement",
    "Conducteur de chien de sang : communiquer avec le gardien ou l’accueil",
  ],
  nearby: [
    { place: "Rivière-à-Pierre", items: "essence, épicerie, guichet Desjardins", distance: "environ 3,5 km de l’accueil" },
    { place: "Saint-Raymond", items: "hôpital, restaurant, essence, épicerie", distance: "environ 35 km" },
  ],
  rules: [
    "Aucune autre activité de chasse ou de pêche pendant la chasse à l’orignal, sauf la villégiature dans les zones vertes.",
    "Aucun permis de femelle adulte.",
    "Récolte de veaux interdite.",
    "Pour la plupart des secteurs, des activités forestières peuvent avoir lieu en période de chasse.",
    "La réserve peut restreindre ou modifier certains secteurs (routes, coupes, inondations, etc.).",
  ],
  timeline: [
    "Vers 6 h — Départ",
    "12 h–13 h — Arrivée prévue dans la région / à l’accueil selon la route",
    "13 h 45 — Rendez-vous officiel d’enregistrement",
    "Après enregistrement — Départ vers Desrochers / accès chalet",
    "16 h 30 — Début officiel de la chasse",
  ],
  confirm: "Peut-on effectuer l’enregistrement plus tôt que 13 h 45 ou faire une partie de l’enregistrement à l’avance ?",
};

export const GROUP_PLAN = {
  depart: "2 octobre 2026 vers 6 h",
  arrive: "entre 12 h et 13 h",
  drive: "Estimation du groupe : environ 1 h 15",
};
